import { FieldValues, FieldPath, useFormContext } from "react-hook-form";

import { TextAreaInputGroup, TextAreaInputGroupProps } from "../TextAreaInputGroup";

type Props<Data extends FieldValues = FieldValues> = {
  name: FieldPath<Data>;
} & TextAreaInputGroupProps;

export const TextAreaControlGroup = <Data extends FieldValues = FieldValues>({
  name,
  error,
  ...props
}: Props<Data>) => {
  const { register, formState, getFieldState } = useFormContext<Data>();
  const fieldState = getFieldState(name, formState);

  return (
    <TextAreaInputGroup
      {...props}
      {...register(name)}
      invalid={!!fieldState.error}
      error={error || fieldState.error?.message}
    />
  );
};
